import get from 'lodash/get';
import { CheckoutState } from '../../state';

export const getOrder = (state: CheckoutState) => get(state, 'order', {});
